// src/components/views/SignupView.js
import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { UserCheck, Mail, Phone, Shield } from 'lucide-react';

// 경로 수정됨 (../../)
import { fireAuth as auth, fireDB as db, appId } from '../../services/firebase';

const COMMON_PASSWORD = "law_quiz_common_pass_2024!";

export default function SignupView({ onSuccess, onBack }) {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.name) return;
    setIsSubmitting(true);
    
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, COMMON_PASSWORD);
      const user = userCredential.user;

      const data = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || '',
        role: 'user',
        createdAt: new Date().toISOString(),
        loginCount: 1,
        totalSolved: 0,
        correctCount: 0,
        progress: 0
      };

      await setDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'profile', 'info'), data);
      await setDoc(doc(db, 'artifacts', appId, 'public', 'data', 'user_roster', user.uid), {
        uid: user.uid,
        name: formData.name,
        email: formData.email,
        joinedAt: new Date().toISOString()
      });
      
      onSuccess(data);
    } catch (err) {
      console.error("Signup failed", err);
      if (err.code === 'auth/email-already-in-use') {
        setError('이미 가입된 이메일입니다. 로그인 화면으로 돌아가주세요.');
      } else {
        setError('회원가입 중 오류가 발생했습니다.');
      }
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex justify-center px-4 py-10">
      <div className="bg-slate-800 border border-slate-700 p-8 rounded-2xl shadow-2xl w-full max-w-md relative">
        <button onClick={onBack} className="absolute top-4 right-4 text-slate-500 hover:text-white text-xs underline">뒤로가기</button>
        <h2 className="text-2xl font-bold mb-6 text-center text-white">회원가입</h2>
        
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">이름 (필수)</label>
            <div className="flex items-center bg-slate-900 border border-slate-600 rounded-lg px-3">
               <UserCheck className="w-5 h-5 text-slate-500 mr-2" />
               <input required className="w-full bg-transparent py-3 text-white outline-none" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="홍길동" />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">이메일 (필수)</label>
            <div className="flex items-center bg-slate-900 border border-slate-600 rounded-lg px-3">
               <Mail className="w-5 h-5 text-slate-500 mr-2" />
               <input required type="email" className="w-full bg-transparent py-3 text-white outline-none" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} placeholder="email@example.com" />
            </div>
          </div>
          
          <div className="bg-slate-700/30 p-3 rounded-lg border border-slate-600/50">
            <label className="block text-sm font-medium text-slate-300 mb-1">전화번호 (선택)</label>
            <div className="flex items-center bg-slate-900 border border-slate-600 rounded-lg px-3 mb-2">
               <Phone className="w-4 h-4 text-slate-500 mr-2"/>
               <input type="tel" className="w-full bg-transparent py-3 text-white outline-none" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} placeholder="010-0000-0000" />
            </div>
            <p className="text-[11px] text-indigo-300 flex items-center">
               <Shield className="w-3 h-3 mr-1 inline" />
               전화번호는 경품 및 격려 목적으로만 사용됩니다.
            </p>
          </div>

          {error && <p className="text-red-400 text-xs text-center font-bold">{error}</p>}
          
          <button type="submit" disabled={isSubmitting} className="w-full bg-indigo-600 hover:bg-indigo-500 text-white py-3 rounded-lg font-bold transition shadow-lg mt-4 disabled:opacity-50">
            {isSubmitting ? '가입 처리 중...' : '가입 완료'}
          </button>
        </form>
      </div>
    </div>
  );
}